if( $('.professor__contact-add-numb').is(':empty')) {
    $('.professor__contact-add').css('display', 'none');
}

